const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/usz/eCheckin/sections/Kosten.tsx';
import { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { CIS4mSingleCheckbox } from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { Alert } from 'App/components/Alert/Alert';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { LabelLink } from 'App/components/eCheckin/components/fields/LabelLink';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import { generatePaths } from 'App/components/eCheckin/utils';
import textMap from '../translations';

export const Kosten = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATHS = generatePaths(path, ['costAndConsentData', 'privacyPolicy'] as const);

    const { formatMessage } = useIntl();
    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <Alert color={'info'} hideIcon>
                <div dangerouslySetInnerHTML={{ __html: formatMessage(textMap.costsAndConsentText) }} />
            </Alert>
            <CIS4mSingleCheckbox
                label={formatMessage(textMap.costsAndConsentCheckbox)}
                path={PATHS.costAndConsentData}
                required
            />
            <CIS4mSingleCheckbox
                label={formatMessage(textMap.privacyPolicyCheckbox, {
                    link: (
                        <LabelLink
                            key="privacyPolicyLink"
                            text={textMap.privacyPolicyLink}
                            url="https://www.usz.ch/de/datenschutz.html"
                        />
                    ),
                })}
                path={PATHS.privacyPolicy}
                required
            />
        </ECheckinSection>
    );
});

Kosten.displayName = 'Kosten';

export default Kosten;
